import { FourWeekForecastReportRequestModel } from '../api/models/FourWeekForecastReportRequestModel';
import { FourWeekForecastReportFormModel } from '../models';

export const dataFormToRequest = (
  data: FourWeekForecastReportFormModel
): FourWeekForecastReportRequestModel => {
  return {
    month: data.month,
    currency_id: data?.with_revenue && data.currency ? Number(data.currency.id) : null,
    fixed_at: data?.with_revenue && data?.fixed_at ? Number(data?.fixed_at) : null,
    rate_ids: (data?.rates || []).map(item => Number(item)),
    room_types: data?.roomTypeIds,
    sub_filter: data?.sub_filter,
    filter: data?.filter,
    gross_revenue: data?.with_revenue ? data?.gross_revenue : false,
    card_id: data?.company?.id,
    with_revenue: data?.with_revenue,
    currency_application: data?.with_revenue ? data?.currency_application : null,
    group_by: data.group_by,
    file_type: data.file_type,
  };
};
